<template>
	<div id="organizador-dashboard-page">
		<div class="dashboard-menu">
			<div class="dashboard-menu-org">
				<div class="organizador-activo" v-if="orAc" @click.prevent="showPromptOrganizaciones()">
					<div class="organizador-logo" v-if="orAc.OrganizadorLogo" :style="{ 'background-color': '#' + orAc.OrganizadorBackgroundColor}">
						<img :src="orAc.OrganizadorLogo" :alt="orAc.OrganizadorNombre">
					</div>
					<span class="organizador-nombre">{{ orAc.OrganizadorNombre }}</span>
				</div>
			</div>
			<div class="dashboard-menu-nav">
				<router-link class="menu-item" :to="{ name: 'organizador-eventos' }" :class="{ 'active': $route.name === 'organizador-eventos' || $route.name === 'organizador-evento' || $route.name === 'organizador-evento-estadisticas' || $route.name === 'organizador-evento-tickets' || $route.name === 'organizador-evento-cortesias' || $route.name === 'organizador-evento-promotores'}">
					<i class='bx bx-calendar-star' ></i>
					<span>Mis eventos</span>
				</router-link>
				<!-- <router-link class="menu-item" :to="{name: 'organizador-mi-organizacion'}" :class="{ 'active': $route.name === 'organizador-mi-organizacion'}">
					Mi organización
				</router-link> -->
				<router-link v-if="orAc.Permisos.includes('VerUsuariosOrganizacion')" class="menu-item" :to="{name: 'organizador-usuarios'}" :class="{ 'active': $route.name === 'organizador-usuarios'}">
					<i class='bx bx-user-pin' ></i>
					<span>Usuarios</span>
				</router-link>
				<router-link v-if="orAc.Permisos.includes('VerSegmentosOrganizacion')" class="menu-item" :to="{name: 'organizador-segmentos'}" :class="{ 'active': $route.name === 'organizador-segmentos'}">
					<i class='bx bx-sitemap'></i>
					<span>Segmentos</span>
				</router-link>
				<router-link class="menu-item" :to="{name: 'organizador-productos'}" :class="{ 'active': $route.name === 'organizador-productos'}">
					<i class='bx bx-basket'></i>
					<span>Productos</span>
				</router-link>
			</div>
		</div>
		<div class="dashboard-wrapper">
			<router-view name="organizador" :key="1"></router-view>
		</div>
		<modal name="promptOrganizaciones" class="promptOrganizaciones" transition="scale" :clickToClose="true">
			<div class="organizaciones-close" @click="$modal.hide('promptOrganizaciones')">
				<i class='bx bx-x'></i>
			</div>
			<div class="organizaciones-content">
				<div class="organizaciones-header">
					<span class="title">Elegir organizador</span>
					<p>Selecciona la organización que deseas gestionar</p>
				</div>
				<div class="organizaciones-main">
					<div class="organizacion" @click.prevent="elegirOrganizador(org.OrganizadorId)" v-for="org in user.Organizaciones" :key="org.OrganizadorId">
						<div class="organizacion-left" v-if="org.OrganizadorLogo">
							<img :src="org.OrganizadorLogo" :alt="org.OrganizadorNombre">
						</div>
						<div class="organizacion-right">
							<span class="nombre">{{ org.OrganizadorNombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import { mapState, mapGetters }  from 'vuex';

	export default {
		data(){
			return{
				
			}
		}, 
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),
		},
		methods: {
			showPromptOrganizaciones(){
				if(this.user.Organizaciones.length > 1){
					this.$modal.show('promptOrganizaciones')
				}
			},
			elegirOrganizador(org){
				if(Number(org) !== Number(this.organizadorActivo)){
					this.$store.dispatch("AuthModule/setOrganizadorActivo", Number(org));
					this.$router.push({ name: 'organizador-dashboard' })
					location.reload();
				}

				this.$modal.hide('promptOrganizaciones');
			}
		}
	}
</script>

<style lang="scss" scoped>
	#organizador-dashboard-page{
		width: 100%;
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 0px;
		min-height: calc(100vh - 476px - 140px);

		.dashboard-menu{
			width: 100%;
			height: 60px;
			padding: 0px 40px;
			// background-color: var(--color-darker);
			border-bottom: 1px solid #ebebeb;
			@include flex(row, flex-start, center);

			.dashboard-menu-nav{
				@include flex(row, flex-start, center);

				.menu-item{
					@include flex(row, center, center);
					color: var(--color-darker);
					font-size: 14px;
					font-weight: var(--fw-400);
					text-decoration: none;
					margin-right: 20px;
					height: 60px;
					padding: 0px 8px;
					box-shadow: none;

					i{
						margin-right: 6px;
						font-size: 18px;
					}
					
					&:last-child{
						margin-right: 0px;
					}

					&:hover{
						// color: var(--color-primary);
						opacity: 0.8;
					}

					&.active{
						box-shadow: inset 0 -4px 0 var(--color-darker);
						font-weight: var(--fw-700);
					}
				}
			}

			.dashboard-menu-org{
				margin-right: 24px;
				padding-right: 24px;
				height: 100%;
				border-right: 1px solid #ebebeb;
				@include flex(row, flex-end, center);

				.organizador-activo{
					width: 100%;
					height: 100%;
					@include transition(all .2s);
					cursor: pointer;
					@include flex(row, flex-end, center);
					
					&:hover{
						opacity: 0.8;
					}

					.organizador-logo{
						@include flex(row, center, center);
						padding: 4px;
						margin-right: 8px;
						width: 30px;
						height: 30px;
						border-radius: 99%;

						img{
							height: 100%;
							width: 100%;
							object-fit: contain;
						}
					}

					.organizador-nombre{
						font-size: 13px;
						line-height: 1em;
						font-weight: var(--fw-600);
						font-family: var(--font-sora);
					}
				}
			}
		}

		.dashboard-wrapper{
			width: 100%;
			padding: 40px;
			@include flex(column, flex-start, flex-start);
		}
	}

	@media screen and (max-width: 850px){
		#organizador-dashboard-page{
			min-height: unset;

			.dashboard-menu{
				width: 100%;
				height: 52px;
				padding: 0px 18px;

				.dashboard-menu-nav{
					.menu-item{
						height: 52px;
					}
				}

				.dashboard-menu-org{
					margin-right: 12px;
					padding-right: 12px;

					.organizador-activo{
						.organizador-logo{
							margin-right: 0px;
							width: 28px;
							height: 28px;
							padding: 3px;
						}

						.organizador-nombre{
							display: none;
						}
					}
				}
			}

			.dashboard-wrapper{
				padding: 20px 6px;
			}
		}
	}

	@media screen and (max-width: 670px){
		#organizador-dashboard-page{
			.dashboard-menu{

				.dashboard-menu-nav{
					width: calc(100% - 53px);
					overflow-x: scroll;

					.menu-item{
						font-size: 13px;
						margin-right: 12px;
						flex-wrap: nowrap;
						flex-shrink: 0;

						i{
							font-size: 17px;
							margin-right: 5px;
						}

						&.active{
							box-shadow: inset 0 -3px 0 var(--color-darker);
						}
					}
				}

				.dashboard-menu-org{
					width: 41px;
				}
			}
		}
	}
</style>